export default __webpack_public_path__ + "static/media/TrashTransparent.8b8dbaa0.svg";